{
  "api": {
    "locationValidationTitle": "Kami tidak dapat memvalidasi lokasi Anda",
    "thresholdTitle": "Belum waktunya untuk check-in",
    "warehouseUnavailableTitle": "Gudang tidak tersedia",
    "warehouseUnavailableMessage": "Silakan hubungi petugas fasilitas untuk melanjutkan check-in manual",
    "characterLimitTitle": "Input melebihi batas karakter",
    "genericTitle": "Check-in gagal. Silakan coba lagi.",
    "recaptchaTitle": "Verifikasi gagal",
    "recaptchaMessage": "Kami tidak dapat memverifikasi permintaan Anda. Silakan coba lagi atau hubungi petugas fasilitas."
  }
}
